import { render } from "./worldDetails.vue?vue&type=template&id=7517739c"
import script from "./worldDetails.vue?vue&type=script&lang=js"
export * from "./worldDetails.vue?vue&type=script&lang=js"

import "./worldDetails.vue?vue&type=style&index=0&id=7517739c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__